import React, { useEffect, useState } from "react";
import { Mail, Phone, Trash2, IdCard, GraduationCap } from "lucide-react";
import { api } from "@/lib/api";

const STATUSES = ["yeni", "ön ödeme alındı", "kayıt tamamlandı", "iptal"];

export default function AdminEnrollments() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/enrollments").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.put(`/admin/enrollments/${id}/status`, { status });
    load();
  };
  const remove = async (id) => {
    if (!window.confirm("Kaydı silmek istediğinize emin misiniz?")) return;
    await api.delete(`/admin/enrollments/${id}`);
    load();
  };

  return (
    <div>
      <span className="section-eyebrow">Yönetim</span>
      <h1 className="font-display text-4xl mt-2 mb-8">Kayıt Formları</h1>

      <div className="space-y-4">
        {items.map((m) => (
          <div key={m.id} className="bg-surface border border-white/10 p-6">
            <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
              <div>
                <div className="font-display text-xl">{m.full_name}</div>
                <div className="text-xs text-white/50 mt-1">{new Date(m.created_at).toLocaleString("tr-TR")}</div>
              </div>
              <div className="flex items-center gap-2">
                <select
                  value={m.status}
                  onChange={(e) => setStatus(m.id, e.target.value)}
                  className="bg-black border border-white/10 text-xs px-2 py-1.5 text-white/80"
                >
                  {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
                <button onClick={() => remove(m.id)} className="text-white/60 hover:text-red-400 p-2"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            <div className="flex flex-wrap gap-4 text-sm text-white/70 mb-2">
              <a href={`mailto:${m.email}`} className="flex items-center gap-2 hover:text-gold"><Mail className="w-3.5 h-3.5" /> {m.email}</a>
              <a href={`tel:${m.phone}`} className="flex items-center gap-2 hover:text-gold"><Phone className="w-3.5 h-3.5" /> {m.phone}</a>
              <span className="flex items-center gap-2"><IdCard className="w-3.5 h-3.5" /> {m.tc_no}</span>
              <span className="flex items-center gap-2"><GraduationCap className="w-3.5 h-3.5" /> {m.program}</span>
            </div>
            {m.start_date && <div className="text-xs text-white/40">Başlangıç: {m.start_date} · Eğitmen: {m.instructor}</div>}
            <div className="text-xs text-gold/70 mt-2">İmza: {m.signature_name}</div>
          </div>
        ))}
        {items.length === 0 && <div className="text-center text-white/50 py-16">Henüz kayıt formu yok.</div>}
      </div>
    </div>
  );
}
